import React from "react";

export default () => (
  <div className="footer text-muted">
    <div className="footer-content">
      &copy; {new Date().getFullYear()} Sustainable Building Solutions, LLC
    </div>
  </div>
);
